// 网易rem
(function (win, lib) {
  const flexible = lib.flexible || (lib.flexible = {})
  function a () {
    if (parseInt(document.documentElement.clientWidth) > 550) {
      document.documentElement.style.fontSize = 720 / 24 + 'px'
    } else {
      document.documentElement.style.fontSize = document.documentElement.clientWidth / 13.8 + 'px'
    }
  }
  let b = null
  flexible.dpr = 1
  flexible.rem = 100
  flexible.rem2px = function (d) {
    let val = parseFloat(d * 75 / 100) * this.rem
    if (typeof d === 'string' && d.match(/rem$/)) {
      val += 'px'
    }
    return val
  }
  flexible.px2rem = function (d) {
    let val = parseFloat(d) / this.rem
    if (typeof d === 'string' && d.match(/px$/)) {
      val += 'rem'
    }
    return val
  }
  win.addEventListener('resize',
    function () {
      clearTimeout(b)
      b = setTimeout(a, 100)
    },
    !1)
  a()
}(window, window.lib || (window.lib = {})))
